import React, { useState } from "react";
import Body from "./Body";
import { useParams } from "react-router-dom";

const ProgramDetails = () => {
  const params = useParams();

  const [filter, setFilter] = useState("all");
  const [classesFilter, setClassesFilter] = useState([]);

  console.log(params.id);

  const _this = { filter, setFilter,classesFilter, setClassesFilter };
  return <Body {..._this} />;
};

export default ProgramDetails;
